import { ArrowBack } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomJsonEditer from "../../elements/CustomJsonEditer";
import CustomList from "../../elements/CustomList";
import CustomPopover from "../../elements/CustomPopover";
import { showSnackbar } from "../../redux/actions/commonAction";

const FormBuilder = ({
  data = [],
  submitLabel = "Submit",
  onSubmit = () => {},
  onCancel,
}) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({});

  useEffect(() => {
    let defaultState = {};
    for (const obj of data) {
      defaultState[obj.name] = obj.default;
    }
    setState(defaultState);
  }, [data]);

  const handleChange = (event) => {
    const { name, value, checked, type } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleList = (el, value) => {
    setState((prevState) => ({
      ...prevState,
      [el.name]: value,
    }));
  };

  const handleErrorInJsonEditor = (ele) => {
    dispatch(
      showSnackbar({
        message: "Error in JSON formatting",
        severity: "error",
        open: true,
      })
    );
  };

  const handleSubmit = () => {
    onSubmit(state);
  };

  const renderElement = (el) => {
    switch (el.type) {
      case "bool":
        return (
          <FormControlLabel
            title={el.description}
            fullWidth
            variant="outlined"
            control={
              <Checkbox
                defaultChecked={el.default || false}
                name={el.name}
                onChange={handleChange}
              />
            }
            label={el.name}
          />
        );
      case "string":
      case "number":
        return (
          <TextField
            title={el.description}
            disabled={el.disabled}
            fullWidth
            label={el.name}
            variant="outlined"
            type={el.type === "number" ? "number" : "text"}
            value={state[el.name] || ""}
            name={el.name}
            onChange={handleChange}
            InputLabelProps={{
              shrink: true,
            }}
          />
        );
      case "list(string)":
        return (
          <CustomList
            title={el.description}
            defaultValue={state[el.name] || []}
            label={el.name}
            disabled={el.disabled}
            onChange={(value) => handleList(el, value)}
          />
        );
      case "map(string)":
        return (
          <CustomPopover
            title={el.description}
            element={el}
            onChange={(value) => handleList(el, value)}
          />
        );

      default:
        return (
          <CustomJsonEditer
            title={el.description}
            element={el}
            onChange={(value) => handleList(el, value)}
            handleError={handleErrorInJsonEditor}
          />
        );
    }
  };

  return (
    <Box my={4}>
      <Grid container spacing={4} alignItems="stretch">
        {data.length > 0 &&
          data.map((el) => {
            return (
              <Grid key={el.name} item xs={12} sm={6} md={4}>
                {renderElement(el)}
              </Grid>
            );
          })}
      </Grid>
      <Box
        display="flex"
        justifyContent="center"
        sx={{ gridGap: "30px", mt: 5 }}
        width="100%"
      >
        <Button
          startIcon={<ArrowBack />}
          sx={{ width: "100px" }}
          variant="outlined"
          onClick={onCancel}
        >
          Back
        </Button>
        <Button
          sx={{ width: "220px" }}
          variant="contained"
          onClick={handleSubmit}
        >
          {submitLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default FormBuilder;
